import { render, staticRenderFns } from "./createSocial.vue?vue&type=template&id=35238da5&scoped=true&"
import script from "./createSocial.vue?vue&type=script&lang=js&"
export * from "./createSocial.vue?vue&type=script&lang=js&"
import style0 from "./createSocial.vue?vue&type=style&index=0&id=35238da5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35238da5",
  null
  
)

export default component.exports